import z from "zod";

export const postVehicleIntegrationSchema = z.object({
	identifier: z.string().min(1, "Identifier is required"),
});

export type PostVehicleIntegrationSchema = z.infer<typeof postVehicleIntegrationSchema>;
